import React from "react";

const LoaderBar = () => {
  return (
    <div className="loader">
      <div className="bar"></div>
    </div>
  );
};

export default LoaderBar;
